import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "blog-area pt-100 pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = {
  class: "d-flex justify-content-between align-items-center flex-wrap",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "blog-single-item transition-y" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "blog-content" }
const _hoisted_8 = { class: "d-flex align-items-center flex-wrap ps-0 mb-0" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "section-title mw-860" }, [
          _createElementVNode("span", { class: "top-title" }, "المدونة"),
          _createElementVNode("h2", null, "أحدث المقالات والنصائح لكم")
        ], -1)),
        _createVNode(_component_RouterLink, {
          to: "/blog",
          class: "read-more style-two text-grey-teal"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" عرض جميع المقالات ", -1),
            _createElementVNode("i", { class: "ti ti-arrow-left" }, null, -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogPosts, (post, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(_ctx.getColumnClass(index)),
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": "200"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_RouterLink, {
                to: post.detailsLink,
                class: "d-block blog-img"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: post.image,
                    alt: post.title
                  }, null, 8, _hoisted_6)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_RouterLink, {
                  to: post.tagLink,
                  class: "tag"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(post.category), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("h3", null, [
                  _createVNode(_component_RouterLink, {
                    to: post.detailsLink
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(post.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", _hoisted_9, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ti ti-calendar-week" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(post.date), 1)
                  ]),
                  _createElementVNode("li", _hoisted_10, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ti ti-clock" }, null, -1)),
                    _createElementVNode("span", null, "قراءة " + _toDisplayString(post.readTime) + " دقائق", 1)
                  ])
                ])
              ])
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}